import React from 'react'
import { connect } from 'react-redux'
import variables from '../../../theme/variables.scss'
import * as Chart from './Base-chart'

export const Index = ({ labsData, labsModalData, currentLabs, type }) => {
    return (
        <div>
            <Chart.Index
                title="Na"
                labsData={labsData}
                labsModalData={labsModalData}
                currentLabs={currentLabs}
                type={type}
                annotationRef={[
                    {
                        type: 'line',
                        mode: 'horizontal',
                        yMin: 135,
                        yMax: 135,
                        borderWidth: 1,
                        borderColor: variables.purple,
                        borderDash: [1, 1],
                        label: {
                            position: 'start',
                            display: true,
                            backgroundColor: 'rgba(0, 0, 0, 0)',
                            displayColors: false,
                            color: variables.gray700,
                            content: ['135'],
                            textAlign: 'start',
                            font: {
                                size: 10,
                            },
                        },
                    },
                    {
                        type: 'line',
                        mode: 'horizontal',
                        yMin: 145,
                        yMax: 145,
                        borderWidth: 1,
                        borderColor: variables.purple,
                        borderDash: [1, 1],
                        label: {
                            position: 'start',
                            display: true,
                            backgroundColor: 'rgba(0, 0, 0, 0)',
                            displayColors: false,
                            color: variables.gray700,
                            content: ['145'],
                            textAlign: 'start',
                            font: {
                                size: 10,
                            },
                        },
                    },
                ]}
            />
        </div>
    )
}

const mapStateToProps = (state) => ({
    labsData: state.labsList.labsData,
    labsModalData: state.labsList.labsModalData,
    currentLabs: state.labs.currentLabs,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Index)
